import { amtStr } from "./numFormatter"

export const formatNumbertoK = (value: number) => {
  return `${amtStr(value / 1_000)}K`
}